import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DragDropDirective } from './dragDrop.directive';
import { ConfigureComponent } from './pages/configure/configure.component';
import { CoreComponent } from './pages/core/core.component';
import { ProjectComponent } from './pages/core/project/project.component';
import { LandingComponent } from './pages/landing/landing.component';

@NgModule({
	declarations: [
		AppComponent,
		ConfigureComponent,
		CoreComponent,
		LandingComponent,
		ProjectComponent,
		DragDropDirective
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		ReactiveFormsModule,
		NgSelectModule,
		FormsModule,
		TooltipModule.forRoot(),
	],
	providers: [
		{ provide: LocationStrategy, useClass: PathLocationStrategy }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
